import { SearchPndFormModel } from "@/model/table/tableViewModel";
import { GetFileType } from "@/helper/shareHelper";

export function ConvertToWhtCertificateTable(_whtCertificateDetail: Array<any>) {
  const whtCertificateDetail = {
    countWhtCertificate: _whtCertificateDetail.length,
    detailList: [] as any,
  };

  if (_whtCertificateDetail && _whtCertificateDetail.length > 0) {
    _whtCertificateDetail.forEach((whtItemModel: any) => {
      whtCertificateDetail.detailList.push({
        contactId: whtItemModel.contactId,
        itemList: whtItemModel.itemList,
        subTotal: whtItemModel.subTotal,
        id: whtItemModel.whtCertificateId,
        whtDate: whtItemModel.whtDate,
        whtNumber: whtItemModel.whtNumber,
        whtTotal: whtItemModel.whtTotal,
        sourceId: whtItemModel.sourceId,
        sourceType: whtItemModel.sourceType,
      });
    });
  }

  return whtCertificateDetail;
}
export function ConvertToSearchPndFormRequest(searchTransaction: any) {
  const searchTransactionRequest: SearchPndFormModel = {
    pndNumber: searchTransaction.formNumber ? searchTransaction.formNumber : "",
    fromDate: searchTransaction.fromDate,
    toDate: searchTransaction.toDate,
    fromSubTotal: searchTransaction.fromTransactionAmount ? searchTransaction.fromTransactionAmount.ToNumber() : null,
    toSubTotal: searchTransaction.toTransactionAmount ? searchTransaction.toTransactionAmount.ToNumber() : null,
    fromWhtTotal: searchTransaction.fromNetTaxCreditAmount ? searchTransaction.fromNetTaxCreditAmount.ToNumber() : null,
    toWhtTotal: searchTransaction.toNetTaxCreditAmount ? searchTransaction.toNetTaxCreditAmount.ToNumber() : null,
    filingType: searchTransaction.filingType,
  };
  return searchTransactionRequest;
}
export function ConvertToPndDetailById(_pndDetail: any) {
  const pndDetail = {
    countWhtCertificate: _pndDetail.countWhtCertificate,
    filingCaseType: _pndDetail.filingCaseType,
    filingRound: _pndDetail.filingRound,
    filingType: _pndDetail.filingType,
    isClosingEntry: _pndDetail.isClosingEntry,
    isDeleted: _pndDetail.isDeleted,
    isFiled: _pndDetail.isFiled,
    isPaid: _pndDetail.isPaid,
    netAmount: _pndDetail.netAmount,
    pndDate: _pndDetail.pndDate,
    pndId: _pndDetail.pndId,
    pndNumber: _pndDetail.pndNumber,
    pndType: _pndDetail.pndType,
    status: _pndDetail.status,
    subTotal: _pndDetail.subTotal,
    surchargeAmount: _pndDetail.surchargeAmount,
    whtForInsertPndModelList: _pndDetail.whtForInsertPndModelList,
    whtTotal: _pndDetail.whtTotal,
    createDateTime: new Date(_pndDetail.createDateTime),
  };

  return pndDetail;
}

export function ConvertToFileStoragePnd(fileStoragePndList: Array<any>) {
  const fileStoragePnd: any = [];

  if (fileStoragePndList.length > 0) {
    fileStoragePndList.forEach((item: any) => {
      fileStoragePnd.push({
        createDateTime: item.uploadDateTime,
        fileFullUrl: item.fileUrl,
        fileName: item.fileName,
        name: item.fileName,
        fileType: item.fileContentType ? item.fileContentType : GetFileType(item.fileName),
        id: item.fileId,
        userId: item.uploadUserId,
      });
    });
  }
  return fileStoragePnd;
}

export function ConvertToClosingEntryPndModelFromMongo(_closingEntryPndModelFromMongo: any) {
  const closingEntryPndModelFromMongo = {
    journalModel: _closingEntryPndModelFromMongo.journalModel,
    expenseModel: _closingEntryPndModelFromMongo.expenseModel,
    pndId: _closingEntryPndModelFromMongo,
    pndType: _closingEntryPndModelFromMongo.pndType,
    isClosingEntry: _closingEntryPndModelFromMongo.isClosingEntry,
  };

  return closingEntryPndModelFromMongo;
}

export function ConvertToUpdateIsFiledPnd(_pndIsFiledDetail: any, reference: string) {
  const pndUpdateIsFiledOption = {
    pndId: _pndIsFiledDetail.pndId,
    pndType: _pndIsFiledDetail.pndType,
    reference: reference,
    filedType: _pndIsFiledDetail.filedType,
    isFiled: _pndIsFiledDetail.isFiled,
  };

  return pndUpdateIsFiledOption;
}

export function ConvertToWhtDetailListForPnd(_whtList: any) {
  const whtList: any = [];
  if (_whtList && _whtList.length > 0) {
    _whtList.forEach((_whtItem: any) => {
      const wht = {
        id: _whtItem.id,
        number: _whtItem.number,
        subTotalForCalculateWht: _whtItem.subTotalForCalculateWht,
        whtTotal: _whtItem.whtTotal,
        pndType: _whtItem.pndType,
        date: _whtItem.date,
        isDeleted: _whtItem.isDeleted,
        transactionId: _whtItem.transactionId,
        transactionType: _whtItem.transactionType,
        items: _whtItem.items,
        contactId: _whtItem.contactId,
      };
      whtList.push(wht);
    });
  }
  return whtList;
}

export function ConvertToCommentLogPnd(_commentList: Array<any>) {
  const commentList: any = [];

  if (_commentList.length > 0) {
    _commentList.forEach((item: any) => {
      commentList.push({
        actionDateTime: item.actionDateTime,
        actionUserId: item.actionUserId,
        commentId: item.commentId,
        commentLogType: item.commentLogType,
        data: item.data,
        note: item.note,
      });
    });
  }
  return commentList;
}
